export type NavChild = {
  label: string;
  to: string;
  /** One short line under the label in the desktop services menu. */
  subtitle?: string;
};

export type NavItem = {
  label: string;
  to: string;
  children?: NavChild[];
};

export const NAV_ITEMS: NavItem[] = [
  { label: 'HOME', to: '/' },
  { label: 'ABOUT US', to: '/about' },
  {
    label: 'OUR SERVICES',
    to: '/services',
    children: [
      { label: 'Courier Services', to: '/services/courier', subtitle: 'Parcels & documents, KSA & abroad' },
      { label: 'Airport to Airport', to: '/services/airport', subtitle: 'Air cargo from Saudi Arabia' },
      { label: 'Door to Door', to: '/services/door-to-door', subtitle: 'By air & sea freight, customs handled' },
      { label: 'Packing And Shipping', to: '/services/packing-and-shipping', subtitle: 'Strong boxes, wrapped and strapped' },
    ],
  },
  { label: 'TRACKING', to: '/tracking' },
  { label: 'CONTACT US', to: '/contact' },
];
